import {FormControlLabel, FormGroup, Slider, Stack, Switch, Typography} from "@mui/material";
import {useState} from "react";

const difficulties = [
    {
        value: 0,
        label: 'R',
        fullLabel: "Rookie",
        multipliers: {
            mlb25: 1,
            mlb26: 1,
        }
    },
    {
        value: 1,
        label: 'V',
        fullLabel: "Veteran",
        multipliers: {
            mlb25: 1.1,
            mlb26: 1.3,
        }
    },
    {
        value: 2,
        label: 'A',
        fullLabel: "All-Star",
        multipliers: {
            mlb25: 1.2,
            mlb26: 1.8,
        }
    },
    {
        value: 3,
        label: 'H',
        fullLabel: "Hall of Fame",
        multipliers: {
            mlb25: 1.3,
            mlb26: 2.3,
        }
    },
    {
        value: 4,
        label: 'L',
        fullLabel: "Legend",
        multipliers: {
            mlb25: 1.4,
            mlb26: 3,
        }
    },
    {
        value: 5,
        label: 'G',
        fullLabel: "G.O.A.T.",
        multipliers: {
            mlb25: 1.5,
            mlb26: 3.5,
        }
    },
];

const calculateStatsTotal = (stats, counts, difficultyMultiplier, isMLBTS26Scoring, isOnline, isDoublePXP) => {
    const statsTotal = stats.reduce((total, stat) => counts[stat.label] * (isMLBTS26Scoring ? stat.mlb26Value : stat.value) + total, 0);

    return Math.floor(statsTotal * calculateMultiplier(difficultyMultiplier, isOnline, isDoublePXP));
}

const calculateMultiplier = (difficultyMultiplier, isOnline, isDoublePXP) =>
    difficultyMultiplier * (isOnline ? 1.5 : 1) * (isDoublePXP ? 2 : 1);

function CalculationSection(props) {
    const [difficultyValue, setDifficultyValue] = useState(0);
    const [isMLBTS26Scoring, setIsMLBTS26Scoring] = useState(true);
    const [isOnline, setIsOnline] = useState(false);
    const [isDoublePXP, setIsDoublePXP] = useState(false);

    const difficultyMultipliers = difficulties.find(d => d.value === difficultyValue).multipliers;
    const difficultyMultiplier = isMLBTS26Scoring ? difficultyMultipliers.mlb26 : difficultyMultipliers.mlb25;

    const battingTotal =
        calculateStatsTotal(props.calculatorItems.batting, props.currentTotals, difficultyMultiplier, isMLBTS26Scoring, isOnline, isDoublePXP);
    const pitchingTotal =
        calculateStatsTotal(props.calculatorItems.pitching, props.currentTotals, difficultyMultiplier, isMLBTS26Scoring, isOnline, isDoublePXP);
    const total = battingTotal + pitchingTotal;

    const difficultyText = (value) => difficulties.find(d => d.value === value)?.fullLabel || "N/A"

    const onDifficultyChange = (event, value) => {
        setDifficultyValue(value);
    }

    const onOnlineChange = (event, isChecked) => {
        setIsOnline(isChecked);
    }

    const onDoublePXPChange = (event, isChecked) => {
        setIsDoublePXP(isChecked);
    }

    const onVersionChange = (event, isChecked) => {
        setIsMLBTS26Scoring(isChecked);
    }

    return (
        <div className="calculation-section">
            <Stack direction="column" spacing={2} alignItems="center" justifyContent="space-evenly">
                <Slider
                    aria-label="Always visible"
                    defaultValue={0}
                    min={0}
                    max={5}
                    getAriaValueText={difficultyText}
                    valueLabelFormat={difficultyText}
                    marks={difficulties}
                    onChange={onDifficultyChange}
                    value={difficultyValue}
                    valueLabelDisplay="on"
                    sx={{width: 500, maxWidth: '85%'}}
                />

                <Stack direction="row" gap={2} justifyContent="space-evenly" sx={{width: 500, maxWidth: "90%"}}>
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={isMLBTS26Scoring} onChange={onVersionChange}/>}
                                          labelPlacement="end" label={isMLBTS26Scoring ? "MLB26" : "MLB25"}/>
                    </FormGroup>
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={isOnline} onChange={onOnlineChange}/>}
                                          labelPlacement="end" label="Online"/>
                    </FormGroup>
                    <FormGroup>
                        <FormControlLabel control={<Switch checked={isDoublePXP} onChange={onDoublePXPChange}/>}
                                          labelPlacement="end" label="Double PXP"/>
                    </FormGroup>
                </Stack>

            </Stack>
            <Stack>
                <Typography variant="h2">{total}</Typography>
                <Typography variant="body2">TOTAL PXP</Typography>
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="space-evenly">
                <Stack>
                    <Typography variant="h3">{battingTotal}</Typography>
                    <Typography variant="body2">BATTING PXP</Typography>
                </Stack>
                <Stack>
                    <Typography variant="h3">{pitchingTotal}</Typography>
                    <Typography variant="body2">PITCHING PXP</Typography>
                </Stack>
            </Stack>
        </div>
    )
}

export default CalculationSection;
